// app/root.tsx
import { LinksFunction } from "@remix-run/node";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
} from "@remix-run/react";
import LoadingProvider from "./contexts/LoadingContext";
 


export const links: LinksFunction = () => [];

export default function App() {
  return (
    <html lang="zh-CN">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <Meta />
        <Links />
      </head>
      <body>
        <LoadingProvider>
          <Outlet />
        </LoadingProvider>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}
